<template>
    <div @click="markerDetail"  v-if="item[1].visible" @mouseover="mouseOver"  @mouseleave="mouseLeave"  class="agency p-lg-24 p-16" :class="{'current' : isDetail}">
        <img class="illust-agency" :src="item[1].image" alt="" loading="lazy" />
        <div class="agency-detail">
            <div class="title-agency guideline-span w-700" >
                <span class=" title ">
                    {{ item[1].title }}
                </span> 
                
                <div class="d-flex gap-8 " > 
                    <div class="pin" :class="{current: isDetail}">
                        <svg width="17" height="22" viewBox="0 0 17 22"  xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.01108 21.777L8.18946 22H9.75522L9.9336 21.777C14.621 15.9153 16.9994 11.2874 16.9994 8.02703C16.9994 3.59382 13.4055 0 8.97234 0C4.53914 0 0.945312 3.59382 0.945312 8.02703C0.945312 11.2874 3.32369 15.9153 8.01108 21.777Z" />
                        </svg>

                        <div class="number" :class="{'-one' : item[1].index === 1, '-two': item[1].index >= 10  }">{{ item[1].index }}</div>
                    </div>
                    <template v-if="item[1].distance">{{ item[1]?.distance }}{{ $t('store_locator.agency.km') }}</template>
                </div>
            </div>
            <div class="address guideline-span mb-4" v-if="item[1].address">
                {{ item[1].address.number }} {{ item[1].address.street }}, {{ item[1].address.postal_code }} {{ item[1].address.city }}
            </div>
            <div class="guideline-small d-flex align-center gap-4 ">
                <template v-if="searchValueNotNull(item[1].schedules)">
                    <div v-if="isOpenNow(item[1].schedules)" >
                        <span class="open">{{ $t('store_locator.agency.open') }} </span>
                        <span v-if="!item[1].schedules[current].afternoon.closing_time.hour"> • {{ $t('store_locator.agency.closeto') }} {{ item[1].schedules[current].morning.closing_time.hour }} : {{ item[1].schedules[current].morning.closing_time.minute }} •  </span>
                        <span v-else> • {{ $t('store_locator.agency.closeto') }} {{ item[1].schedules[current].afternoon.closing_time.hour }}:{{ item[1].schedules[current].afternoon.closing_time.minute }} • </span>
                    </div>
                    <div v-else class="c-red">
                        {{ $t('store_locator.agency.close') }}
                    </div>
                </template>
                
                <a :href="`tel:${item[1].phone}`" class="location" v-if="item[1].phone">  {{ item[1].phone }}</a>
            </div>
            <div class="activities  mt-8 " v-if="!isDetail">
                <span  class="strong w-600">{{ $t('store_locator.agency.activities') }}</span>
                <span v-for="(activity) in item[1].activities.slice(0, 3)" >
                    • {{ activity }}
                </span>
               <a  class="seemore" v-if="item[1].activities.length > 3"> 
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.78245 4.58301V9.56342H4.58203V10.3834H9.78245V15.3838H10.6224V10.3834H15.8229V9.56342H10.6224V4.58301H9.78245Z" fill="black"/>
                    </svg>
                    {{ $t('store_locator.agency.activitiesmore') }} 
                </a>
            </div>
        
            <div class="links-agency mt-16">
                <RenaultButton  is-small is-black :text="$t('store_locator.agency.contact')" v-if="item[1].email" @buttonclicked="contactTracking"/>
                <RenaultButton is-anchor is-small is-black :href="`https://www.google.com/maps/dir/${currentLat},${currentLng}/${item[1].location.lat},${item[1].location.lng}`" :text="$t('store_locator.agency.itinerary')" class="btn-invert" :target="'_blank'" v-if="currentLat"  />
                <RenaultButton is-anchor is-small is-black :href="`https://www.google.com/maps/dir/${item[1].location.lat},${item[1].location.lng}`" :text="$t('store_locator.agency.itinerary')" class="btn-invert" :target="'_blank'" v-else  />
                <RenaultButton  is-small is-black  :text="$t('store_locator.agency.website')" v-if="item[1].website" class="btn-invert" @buttonclicked="websiteTracking"/>
            </div>
            <slot></slot>
        </div>
    </div>
</template>

<script>
import RenaultButton from '../Shared/RenaultButton.vue';
import mixinStore from './mixins';
    export default {
        components: {
            RenaultButton,
        },
        mixins: [mixinStore],
        props: {
            item: {
                type: [Array, Object],
                default: null
            },
            index: {
                type: Number,
                default: 1
            },
            isDetail: {
                type: Boolean,
                default: false
            },
            currentPlace: {
                type: Object
            },
            location: {
                type: Boolean
            }
        },
        computed: {
            currentLat() {
                if(this.location) {
                    return this.currentPlace?.geometry?.location.lat
                }
                else {
                    return this.currentPlace?.geometry?.location.lat()
                }
                
            },
            currentLng() {
                if(this.location ) {
                    return this.currentPlace?.geometry?.location.lng
                }
                else {
                    return this.currentPlace?.geometry?.location.lng()
                }
            },
        },

        methods: {
            markerDetail() {
                this.$emit("markerDetail", this.item, this.index);
            },
            mouseOver() {
                if(!this.isDetail) {
                    let selected =  this.item[0].element.querySelector('.GoogleMapPin')
                    selected.classList.add('active')
                }
            },
            mouseLeave() {
                if(!this.isDetail) {
                    let selected =  this.item[0].element.querySelector('.GoogleMapPin')
                    selected.classList.remove('active')
                }
            },
            contactTracking () {
                window.dataLayer.push({
                    'event':'navigationClick',
                    'brand' : 'originals-services',
                    'countryCode' : this.$store.state.languages.current.toUpperCase(),
                    'languageCode' : this.$store.state.languages.current,
                    'pageType' : 'dealer-locator',
                    'platform': 'local',
                    'businessType': 'transverse', 
                    'buttonText': 'contact', 
                    'destination': `mailto:${this.item[1].email}`,
                    'pageName':`store + ${this.item[1].title}`,
                })
                window.location.href =`mailto:${this.item[1].email}`;
            },

            websiteTracking() {
                window.dataLayer.push({
                    'event':'navigationClick',
                    'brand' : 'originals-services',
                    'countryCode' : this.$store.state.languages.current.toUpperCase(),
                    'languageCode' : this.$store.state.languages.current,
                    'pageType' : 'dealer-locator',
                    'platform': 'local',
                    'businessType': 'transverse', 
                    'buttonText': 'website', 
                    'destination': this.item[1].website,
                    'pageName':`store + ${this.item[1].title}`,
                })
                window.open(this.item[1].website, '_blank');
            }
        },
    }
</script>

<style lang="scss" scoped>

.pin {
    position: relative;

    svg {
        fill: black;
    }

    .number {
        color: white;
        font-size: 12px;
        left: 6px;
        line-height: 1;
        position: absolute;
        top: 3px;

        &.-one {
            left: 7px;
        }

        &.-two {
            left: 4px;
        }
    }

    &.current {
        svg {
            fill: #efdf00;
        }

        .number {
            color: black;
        }
    }
}

.activities {
    color: #424242;
}


a.location {
    color: $black;
}

.title-agency {
    align-items: center;
    display: flex;
    justify-content: space-between;

    .title {
        font-family: $f-nouvelR-bold;
        font-size: 20px;
        line-height: 20px;

        @include teq-breakpoint($medium) {
            font-size: 24px;
            line-height: 28px;
        }
    }
}

.address {
    font-family: $f-nouvelR-semibold;
}

.agency {
    cursor: pointer;
    display: flex;
    gap: 24px;
    transition: 0.3s ease;
    width: 100%;

    @include teq-breakpoint($medium) {
        border: 1px solid #dfdfdf;
    }

    &:hover {
        background: rgba(223, 223, 223, 0.15);
    }

    &.current {
        background: white;
        border: none;
        border-top: 1px solid #dfdfdf;

        &:hover {
            background: white;
        }
    }
}

.links-agency {
    display: flex;
    gap: 8px;
}

.illust-agency {
    display: none;

    @include teq-breakpoint($medium) {
        aspect-ratio: 160/160;
        display: block;
        height: 160px;
        object-fit: cover;
        width: 160px;
    }
}

.agency-detail {
    flex: 2;

    .open {
        color: #02ae16;
    }
}

.btn-invert {
    border: 1px solid white !important;
    filter: invert(1);
}

.activities {
    display: flex;
    flex-direction: column;
    font-size: 12px;
    line-height: 16px;
}

.seemore {
    align-items: center;
    color: $black;
    display: flex;
    font-family: $f-nouvelR-bold;
    font-size: 12px;
    line-height: 16px;
    text-decoration-line: underline;
}
</style>